// useChannelHealth — Polish #20.
//
// Polls GET /api/channel-health every 60 seconds so the Standup widget and
// the optional red banner can react without requiring a manual refresh.
// 60s is short enough for outages to surface within a tick of the regular
// poll cycle, long enough to stay off the hot path (poller_state is tiny).

import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';

export interface ChannelHealthItem {
  channel: string;
  label: string;
  connected: boolean;
  lastPolledAt: string | null;
  lastSuccessAt: string | null;
  consecutiveErrors: number;
  lastError: string | null;
  cursorAgeSeconds: number | null;
  status: 'healthy' | 'warning' | 'error';
  message: string;
}

export interface ChannelHealthResponse {
  overall: 'healthy' | 'warning' | 'error';
  items: ChannelHealthItem[];
  generatedAt: string;
}

export function useChannelHealth() {
  return useQuery<ChannelHealthResponse>({
    queryKey: ['channel-health'],
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 60 * 1000,
    queryFn: () => apiGet<ChannelHealthResponse>('/api/channel-health'),
  });
}
